export default "/_next/static/media/beach-house-interior-1.bc69273a536a51bb58092b2896b92e3a.jpg";